import { JSX } from 'react';
import Tooltip from '../toolTip';
import HorizontalBarGraph from './graphBarHorizontal';
import PercentageDonut from './percentageDonut';

interface OutcomeCategory {
  label: string;
  percentage: number;
  color: string;
  dataLabel: string;
}

interface PositiveOutcomeProps {
  icon?: JSX.Element;
  title: string;
  tooltip?: string;
  totalHouseholds: string;
  valueSubtitle: string;
  unit: string;
  positivePercentage: number;
  positivePercentageLabel: string;
  categories: OutcomeCategory[];
}

export default function PositiveOutcome({
  icon,
  title,
  totalHouseholds,
  valueSubtitle,
  unit,
  positivePercentage,
  positivePercentageLabel,
  categories,
  tooltip,
}: PositiveOutcomeProps) {
  return (
    <div className="bg-white border border-pipgrey-border rounded-xl p-5 flex flex-col gap-6 w-full shadow-sm">
      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-2">
          {icon && <div className="text-primary-vibrant text-lg">{icon}</div>}
          <h4 className="text-base font-semibold text-secondary">{title}</h4>
          {tooltip && <Tooltip label="positive-outcome-info" text={tooltip} />}
        </div>
        <div className="flex items-center justify-between gap-6">
          <div className="flex flex-col gap-3">
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-semibold leading-[38.4px] text-secondary">
                {totalHouseholds}
              </span>
              <span className="text-base font-semibold text-secondary">{unit}</span>
            </div>
            <p className="text-sm font-nunito text-piptext-strong">{valueSubtitle}</p>
          </div>
          <PercentageDonut positivePercentage={positivePercentage} label={positivePercentageLabel} />
        </div>
      </div>
      <HorizontalBarGraph categories={categories} />
    </div>
  );
}
